import { useCallback } from 'react'
import {
  useUpdateDocumentVersionSession,
  useUpdateDocumentVersionSessionEvent,
} from '@/services/queries/document_sessions'
import { useTechnicianPageStore } from './useTechnicianPageStore'

export const useEndSession = () => {
  const currentSessionId = useTechnicianPageStore(
    (state) => state.currentSessionId,
  )
  const currentTechnician = useTechnicianPageStore(
    (state) => state.currentTechnician,
  )
  const lastSessionEventId = useTechnicianPageStore(
    (state) => state.lastSessionEventId,
  )

  const { mutate: updateSession, isPending } = useUpdateDocumentVersionSession()
  const { mutate: updateEvent } = useUpdateDocumentVersionSessionEvent()

  const endSession = useCallback(() => {
    if (currentSessionId && currentTechnician) {
      if (lastSessionEventId) {
        updateEvent({
          documentVersionSessionEventId: lastSessionEventId,
          completedTimestamp: new Date().toISOString(),
          onSuccess: () => {
            updateSession({
              documentVersionSessionId: currentSessionId,
              completedTimestamp: new Date().toISOString(),
              username: currentTechnician,
            })
          },
        })
      } else {
        updateSession({
          documentVersionSessionId: currentSessionId,
          completedTimestamp: new Date().toISOString(),
          username: currentTechnician,
        })
      }
    }
  }, [
    currentSessionId,
    currentTechnician,
    lastSessionEventId,
    updateEvent,
    updateSession,
  ])

  return {
    endSession,
    isPending,
  }
}
